import React, { useEffect, useState } from 'react'
import styles from "./Myproject.module.css"
import { useParams } from 'react-router-dom';
import { delete_project_Api, get_all_project_Api, update_project_Api } from '../../dashboardapi';
import { useToast } from '@chakra-ui/react';


const TrashedProjects = () => {
    const [projects, setProjects] = useState([]);

    const { project } = useParams();

    const toast = useToast();

    const fetchTrashedProjects = async () => {
        let response = await get_all_project_Api();
        if (response.data && response.data.trashed) {
            setProjects(response.data.trashed);
        } else {
            setProjects([])
        }
    };

    useEffect(() => {
        if (project === 'trashedprojects') {
            fetchTrashedProjects();
        }
    }, [])

    const handleDelete = async (id) => {
        let result = await delete_project_Api(id);
        if (result.data) {
            toast({
                title: "Project deleted Successfully",
                description: result.data.message,
                status: "success",
                duration: 2000,
                isClosable: "true"

            })
            setProjects((prev) => prev.filter((items) => items.uuid !== id));
        } else {
            let error = result.error.message || "error Occurred"
            toast({
                title: "Problem deleting project",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"

            })
        }
    }

    const undelete = async (id) => {
        let result = await update_project_Api(id);
        if (result.data) {
            toast({
                title: "Project restored successfully",
                description: result.data.message,
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            fetchTrashedProjects();
        } else {
            let error = result.error.message || "error Occurred"
            toast({
                title: "Failed to restore project",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    return (
        <div className={styles.product_page_outer}>
            <div className={styles.indivprojectouter}>
                <div className={styles.project_heading}>
                    <p>Trash</p>
                </div>
                <div className={styles.indivprojectlist}>
                    {projects.length > 0 ? projects.map((item, i) => (
                        <div key={i} className={styles.indivproject}>
                            <input type='text' name='name' onChange={""} value={item.name} style={{ background: "#f3f3f5" }}></input>
                            {/* <button>Go to editor</button> */}
                            <button onClick={() => undelete(item.uuid)} className={styles.untrash}>Add to my projects</button>
                            <hr style={{ borderColor: "#CCCBD3", marginTop: "24px", borderWidth: "1px" }} />
                            <div className={styles.fileactionbtn}>
                                {/* <button onClick={() => handleRename(item.name)}><img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/edit.png"} alt='rename' /></button> */}
                                {/* <button><img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/settings.png"} alt='settings' /></button> */}
                                <button onClick={() => handleDelete(item.uuid)}><img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/delete.png"} alt='delete' /></button>
                            </div>
                        </div>
                    )) : <p>No Projects in trash</p>}
                </div>
            </div>
        </div>
    )
}

export default TrashedProjects